<template>
  <div class="services">
    <div class="box">
      <table v-if="!isMobile">
        <thead v-if="selectedServiceArea !== 0">
          <th class="enable">Enable</th>
          <th>Service Types</th>
          <th class="license-type">License Type</th>
          <th class="pax-luggage">Max Passenger</th>
          <th class="pax-luggage">Max Luggage</th>
          <th></th>
        </thead>
        <thead v-else>
          <th class="action"></th>
          <th>Service Types</th>
        </thead>
        <tbody>
          <tr v-for="service in services" v-show="service.brandEnabled && selectedServiceArea !== 0" :key="service.id">
            <td class="active">
              <div class="switch" @click="toggleEnable(service.id, service.enabled)">
                <div :class="{'slider':true, 'active':service.enabled, 'disabled':enabledLoading.indexOf(service.id) > -1}"></div>
              </div>
            </td>
            <td class="name">{{ service.name }}</td>
            <td class="license-type">
              <span v-for="licenseType in service.licenseType" :class="['license-type', licenseType]">{{licenseType}}</span>
            </td>
            <td class="pax-luggage">{{ service.maxPassenger }}</td>
            <td class="pax-luggage">{{ service.maxLuggages }}</td>
            <td class="edit"><a class="button xsmall warning"
              v-bind:href="'/#/services/' + selectedBrand + '/' +service.id">Edit Info</a></td>
          </tr>
          <tr v-for="service in services" v-if="service.brandEnabled && selectedServiceArea === 0">
            <td class="action">
              <div :class="['button cta xsmall', enableList.indexOf(service.id) === -1 ? 'default' : 'success']"
                @click="toggleEnableList(service.id)">Enable All</div>
              <div :class="['button cta xsmall', disableList.indexOf(service.id) === -1 ? 'default' : 'error']"
                @click="toggleDisableList(service.id)">Disable All</div>
            </td>
            <td class="name">{{ service.name }}</td>
          </tr>
        </tbody>
      </table>

      <div v-else>

        <div v-if="selectedServiceArea !== 0" class="cards">
          <div v-for="service in services" v-if="service.brandEnabled && selectedServiceArea !== 0" :key="service.id" class="card">
            <div class="card-header">
              <div class="title">
                {{ service.name }}
                <span v-for="licenseType in service.licenseType" :class="['license-type', licenseType]">{{licenseType}}</span>
              </div>
              <div class="status active">
                <div class="switch" @click="toggleEnable(service.id, service.enabled)">
                  <div :class="{'slider':true, 'active':service.enabled, 'disabled':enabledLoading.indexOf(service.id) > -1}"></div>
                </div>
              </div>
            </div>
            <div class="title">
              <div class="label">Max Passenger: </div>
              <div class="value">{{service.maxPassenger }} <i class="fas fa-users"></i></div>
            </div>
            <div class="title">
              <div class="label">Max Luggage: </div>
              <div class="value">{{service.maxLuggages }} <i class="fas fa-suitcase"></i></div>
            </div>
            <div class="edit">
              <a class="button xsmall warning"
              v-bind:href="'/#/services/' + selectedBrand + '/' +service.id"> <i class="fas fa-edit"></i> Edit Info</a>
            </div>
          </div>
        </div>

        <div v-else>
          <table>
            <thead>
              <th class="action"></th>
              <th>Service Types</th>
            </thead>
            <tbody>
              <tr v-for="service in services" v-if="service.brandEnabled && selectedServiceArea === 0">
                <td class="action">
                  <div :class="['button cta xsmall', enableList.indexOf(service.id) === -1 ? 'default' : 'success']"
                    @click="toggleEnableList(service.id)">Enable All</div>
                  <div :class="['button cta xsmall', disableList.indexOf(service.id) === -1 ? 'default' : 'error']"
                    @click="toggleDisableList(service.id)">Disable All</div>
                </td>
                <td class="name">{{ service.name }}</td>
              </tr>
            </tbody>
          </table>

        </div>

      </div>
    </div>

    <div class="box">
      <label>Charter Service</label>
      <table v-if="!isMobile">
        <thead v-if="selectedServiceArea !== 0">
          <th class="enable">Enable</th>
          <th>Service Types</th>
          <th class="license-type">License Type</th>
          <th class="pax-luggage">Max Passenger</th>
          <th class="pax-luggage">Max Luggage</th>
          <th></th>
        </thead>
        <thead v-else>
          <th class="action"></th>
          <th>Service Types</th>
        </thead>
        <tbody>
          <tr v-for="service in charterServices" v-show="service.brandEnabled && selectedServiceArea !== 0" :key="service.id">
            <td class="active">
              <div class="switch" @click="toggleEnable(service.id, service.enabled)">
                <div :class="{'slider':true, 'active':service.enabled, 'disabled':enabledLoading.indexOf(service.id) > -1}"></div>
              </div>
            </td>
            <td class="name">{{ service.name }}</td>
            <td class="license-type">
              <span v-for="licenseType in service.licenseType" :class="['license-type', licenseType]">{{licenseType}}</span>
            </td>
            <td class="pax-luggage">{{ service.maxPassenger }}</td>
            <td class="pax-luggage">{{ service.maxLuggages }}</td>
            <td class="edit"><a class="button xsmall warning"
              v-bind:href="'/#/services/' + selectedBrand + '/' +service.id">Edit Info</a></td>
          </tr>
          <tr v-for="service in charterServices" v-if="service.brandEnabled && selectedServiceArea === 0">
            <td class="action">
              <div :class="['button cta xsmall', enableList.indexOf(service.id) === -1 ? 'default' : 'success']"
                @click="toggleEnableList(service.id)">Enable All</div>
              <div :class="['button cta xsmall', disableList.indexOf(service.id) === -1 ? 'default' : 'error']"
                @click="toggleDisableList(service.id)">Disable All</div>
            </td>
            <td class="name">{{ service.name }}</td>
          </tr>
        </tbody>
      </table>

      <div v-else>

        <div v-if="selectedServiceArea !== 0" class="cards">
          <div v-for="service in charterServices" v-show="service.brandEnabled && selectedServiceArea !== 0" :key="service.id" class="card">
            <div class="card-header">
              <div class="title">
                {{ service.name }}
                <span v-for="licenseType in service.licenseType" :class="['license-type', licenseType]">{{licenseType}}</span>
              </div>
              <div class="status active">
                <div class="switch" @click="toggleEnable(service.id, service.enabled)">
                  <div :class="{'slider':true, 'active':service.enabled, 'disabled':enabledLoading.indexOf(service.id) > -1}"></div>
                </div>
              </div>
            </div>
            <div class="title">
              <div class="label">Max Passenger: </div>
              <div class="value">{{service.maxPassenger }} <i class="fas fa-users"></i></div>
            </div>
            <div class="title">
              <div class="label">Max Luggage: </div>
              <div class="value">{{service.maxLuggages }} <i class="fas fa-suitcase"></i></div>
            </div>
            <div class="edit">
              <a class="button xsmall warning"
              v-bind:href="'/#/services/' + selectedBrand + '/' +service.id"> <i class="fas fa-edit"></i> Edit Info</a>
            </div>
          </div>
        </div>

        <div v-else>
          <table>
            <thead>
              <th class="action"></th>
              <th>Service Types</th>
            </thead>
            <tbody>
              <tr v-for="service in services" v-if="service.brandEnabled && selectedServiceArea === 0">
                <td class="action">
                  <div :class="['button cta xsmall', enableList.indexOf(service.id) === -1 ? 'default' : 'success']"
                    @click="toggleEnableList(service.id)">Enable All</div>
                  <div :class="['button cta xsmall', disableList.indexOf(service.id) === -1 ? 'default' : 'error']"
                    @click="toggleDisableList(service.id)">Disable All</div>
                </td>
                <td class="name">{{ service.name }}</td>
              </tr>
            </tbody>
          </table>

        </div>

      </div>
    </div>

    <div class="box">
      <label>Rental Service</label>
      <table v-if="!isMobile">
        <thead v-if="selectedServiceArea !== 0">
          <th class="enable">Enable</th>
          <th>Service Types</th>
          <th class="license-type">License Type</th>
          <th class="pax-luggage">Max Passenger</th>
          <th class="pax-luggage">Max Luggage</th>
          <th></th>
        </thead>
        <thead v-else>
          <th class="action"></th>
          <th>Service Types</th>
        </thead>
        <tbody>
          <tr v-for="service in rentalServices" v-show="service.brandEnabled && selectedServiceArea !== 0" :key="service.id">
            <td class="active">
              <div class="switch" @click="toggleEnable(service.id, service.enabled)">
                <div :class="{'slider':true, 'active':service.enabled, 'disabled':enabledLoading.indexOf(service.id) > -1}"></div>
              </div>
            </td>
            <td class="name">{{ service.name }}</td>
            <td class="license-type">
              <span v-for="licenseType in service.licenseType" :class="['license-type', licenseType]">{{licenseType}}</span>
            </td>
            <td class="pax-luggage">{{ service.maxPassenger }}</td>
            <td class="pax-luggage">{{ service.maxLuggages }}</td>
            <td class="edit"><a class="button xsmall warning"
              v-bind:href="'/#/services/' + selectedBrand + '/' +service.id">Edit Info</a></td>
          </tr>
          <tr v-for="service in rentalServices" v-if="service.brandEnabled && selectedServiceArea === 0">
            <td class="action">
              <div :class="['button cta xsmall', enableList.indexOf(service.id) === -1 ? 'default' : 'success']"
                @click="toggleEnableList(service.id)">Enable All</div>
              <div :class="['button cta xsmall', disableList.indexOf(service.id) === -1 ? 'default' : 'error']"
                @click="toggleDisableList(service.id)">Disable All</div>
            </td>
            <td class="name">{{ service.name }}</td>
          </tr>
        </tbody>
      </table>

      <div v-else>

        <div v-if="selectedServiceArea !== 0" class="cards">
          <div v-for="service in rentalServices" v-show="service.brandEnabled && selectedServiceArea !== 0" :key="service.id" class="card">
            <div class="card-header">
              <div class="title">
                {{ service.name }}
                <span v-for="licenseType in service.licenseType" :class="['license-type', licenseType]">{{licenseType}}</span>
              </div>
              <div class="status active">
                <div class="switch" @click="toggleEnable(service.id, service.enabled)">
                  <div :class="{'slider':true, 'active':service.enabled, 'disabled':enabledLoading.indexOf(service.id) > -1}"></div>
                </div>
              </div>
            </div>
            <div class="title">
              <div class="label">Max Passenger: </div>
              <div class="value">{{service.maxPassenger }} <i class="fas fa-users"></i></div>
            </div>
            <div class="title">
              <div class="label">Max Luggage: </div>
              <div class="value">{{service.maxLuggages }} <i class="fas fa-suitcase"></i></div>
            </div>
            <div class="edit">
              <a class="button xsmall warning"
              v-bind:href="'/#/services/' + selectedBrand + '/' +service.id"> <i class="fas fa-edit"></i> Edit Info</a>
            </div>
          </div>
        </div>

        <div v-else>
          <table>
            <thead>
              <th class="action"></th>
              <th>Service Types</th>
            </thead>
            <tbody>
              <tr v-for="service in services" v-if="service.brandEnabled && selectedServiceArea === 0">
                <td class="action">
                  <div :class="['button cta xsmall', enableList.indexOf(service.id) === -1 ? 'default' : 'success']"
                    @click="toggleEnableList(service.id)">Enable All</div>
                  <div :class="['button cta xsmall', disableList.indexOf(service.id) === -1 ? 'default' : 'error']"
                    @click="toggleDisableList(service.id)">Disable All</div>
                </td>
                <td class="name">{{ service.name }}</td>
              </tr>
            </tbody>
          </table>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'
import ApiServiceArea from '@/modules/api/pricing/service-area'

export default {
  name: 'services',
  props: ['isMobile'],
  data () {
    return {
      enabledLoading: []
    }
  },
  computed: {
    selectedBrand () { return this.$store.state.pricing.brandId },
    selectedServiceArea () { return this.$store.state.pricing.serviceArea.activeId },
    services () { return this.$store.state.pricing.serviceTypes.list.filter(x => x.brandId === this.selectedBrand && !x.isCharter && !x.isRental) },
    charterServices () { return this.$store.state.pricing.serviceTypes.list.filter(x => x.brandId === this.selectedBrand && x.isCharter) },
    enableList () { return this.$store.state.pricing.serviceTypes.enableList },
    disableList () { return this.$store.state.pricing.serviceTypes.disableList },
    rentalServices () { return this.$store.state.pricing.serviceTypes.list.filter(x => x.brandId === this.selectedBrand && x.isRental) },
  },
  methods: {
    toggleEnable (id, enable) {
      let self = this
      if (self.enabledLoading.indexOf(id) > -1) { return }

      self.enabledLoading.push(id)
      ApiServiceArea.toggleEnable(self, {
        serviceAreaId: self.selectedServiceArea,
        id: id,
        enable: !enable
      }, res => {
        let index = self.enabledLoading.indexOf(id)
        self.enabledLoading.splice(index, 1)
        self.$nextTick().then(() => {
          self.$forceUpdate()
          self.$emit('change')
        })
        self.pricingTabEnable()
      })
    },
    pricingTabEnable () {
      if (this.selectedServiceArea === 0) {
        this.$store.commit('pricing/setServiceTypesIsClickable', true)
      } else {
        let serviceTypes = this.$store.state.pricing.serviceTypes.list.filter(x => x.brandId === this.selectedBrand && x.brandEnabled)
        let value = serviceTypes.map(x => x.enabled).some(x => x === true)
        this.$store.commit('pricing/setServiceTypesIsClickable', value)
      }
    },
    toggleEnableList (id) { this.$store.commit('pricing/updateEnableList', id) },
    toggleDisableList (id) { this.$store.commit('pricing/updateDisableList', id) },
    resetActionList () { this.$store.commit('pricing/resetEnableList') }
  },
  watch: {
    selectedBrand (value) { this.resetActionList() },
    selectedServiceArea (value) { this.resetActionList() }
  },
  mounted () {
    this.pricingTabEnable()
  }
}
</script>

<style lang="scss" scoped>
.box{
  background: #fff;
  border-radius: 2px;
  border: 1px solid #b0c6e4;
  padding: 15px;
  box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);
  margin-bottom: 20px;

  label{
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 5px;
    display: block;
    color: #333;
  }
}

table{
  background: #fff;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  text-align: left;
  border-spacing: 0;

  thead{
    th{
      padding: 5px;
      font-size: 14px;
      color: #0D79F2;
      border-bottom: 1px solid #ddd;
      border-right: 1px solid #eee;

      &:last-child{ border-right: none; }
      &.enable { width: 90px; }
    }
  }
  tbody{
    tr:nth-child(odd){ background: #fafafa; }
    tr:hover td{ background: #f1f1f1; }
    td{
      padding: 5px 7px;
      font-size: 14px;
      border-right: 1px solid #eee;
      border-bottom: 1px solid #eee;

      &.license-type{ width: 200px; }
      &:last-child{ border-right: none; }
    }
    .action{ width: 240px; }
    span.license-type {
      display: inline-block;
      color: #fff;
      padding: 3px 5px;
      margin: 0 5px;
      min-width: 50px;
      border-radius: 3px;
      text-transform: uppercase;
      font-weight: 700;
      text-align: center;

      &.tnc { background-color: #2ab77c; }
      &.tcp { background-color: #3f81a0; }
      &.psc { background-color: #de6c2a; }
    }
    .pax-luggage{ width: 120px; }
    .active{ width: 80px; }
    .edit{ width: 100px; }
  }
  .action, .enable, .active, .edit, .license-type, .pax-luggage{ text-align: center; }
}

.button.default{
  background: #fff;
  color: #333!important;
  border-bottom: 4px solid #ccc;
  box-shadow: 0 0 0 1px #ccc;
}

.switch{
  position: relative;
  display: inline-block;
  vertical-align: top;

  .slider{
    position: relative;
    display: inline-block;
    width: 50px;
    height: 30px;
    border-radius: 20px;
    background: #ccc;
    position: relative;
    cursor: pointer;
    transition:all .25s ease-in-out;

    &.disabled{
      opacity: .4;
      cursor: not-allowed;
    }
    &:before{
      content: '';
      position: absolute;
      top: 4px;
      left: 4px;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background: #fff;
      transition:all .25s ease-in-out;
      box-shadow: 1px 1px 2px rgba(0,0,0, .25);
    }
    &.active{
      background: #57d1b7;
      &:before{ left: 24px; }
    }
  }
  .label{
    display: inline-block;
    vertical-align: 10px;
    margin-left: 5px;
    font-size: 14px;
    color: #555;
    text-transform: uppercase;
  }
}

@media only screen and (max-width: 430px) {
  .cards {
    .card {
      border: 1px solid #ccc;
      margin: 0 10px;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;
      font-weight: 700;

      > div {
        margin-bottom: 3px;
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .name {
          font-weight: 900;
        }
        .amount {
          margin-left: 5px;
          font-size: 14px;
        }
        .status {
          text-transform: uppercase;
          font-size: 12px;
          font-weight: 900;
        }
      }

        span.license-type {
          display: inline-block;
          color: #fff;
          padding: 3px 5px;
          margin: 0 5px;
          margin-right: 0;
          min-width: 50px;
          border-radius: 3px;
          text-transform: uppercase;
          font-weight: 700;
          text-align: center;
          font-size: 12px;

          &.tnc { background-color: #2ab77c; }
          &.tcp { background-color: #3f81a0; }
          &.psc { background-color: #de6c2a; }
        }

      .title {
        display: flex;
        align-items: center;
      }

      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;

        i {
          opacity: 0.3;
        }
      }

      .edit {
        text-align: right;
        margin-bottom: 10px;
        text-transform: uppercase;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pricing/Services.vue